// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.menu-container-riBA0 {
  width: 240px;
  visibility: hidden;
  position: fixed;
  z-index: 3;
  background-color: white;
  border-radius: var(--radius-lg);
  box-shadow: var(--shadow-md);
  border: 1px solid var(--color-neutral-200);
  outline: none;
  padding: 6px 0px;
}

.menu-animation_enter-Kcg_V {
  opacity: 0;
  transform: translateY(-8px);
}

.menu-animation_enterActive-RYONc {
  transition: all 160ms;
  opacity: 1;
  transform: translateY(0px);
}

.menu-animation_exit-E05_Y {
  opacity: 1;
  transform: translateY(0px);
}

.menu-animation_exitActive-Lo7bw {
  transition: all 160ms;
  opacity: 0;
  transform: translateY(-8px);
}
`, "",{"version":3,"sources":["webpack://./../core/src/components/menu/menu.module.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,UAAU;EACV,uBAAuB;EACvB,+BAA+B;EAC/B,4BAA4B;EAC5B,0CAA0C;EAC1C,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,2BAA2B;AAC7B;;AAEA;EACE,qBAAqB;EACrB,UAAU;EACV,0BAA0B;AAC5B;;AAEA;EACE,UAAU;EACV,0BAA0B;AAC5B;;AAEA;EACE,qBAAqB;EACrB,UAAU;EACV,2BAA2B;AAC7B","sourcesContent":[".container {\n  width: 240px;\n  visibility: hidden;\n  position: fixed;\n  z-index: 3;\n  background-color: white;\n  border-radius: var(--radius-lg);\n  box-shadow: var(--shadow-md);\n  border: 1px solid var(--color-neutral-200);\n  outline: none;\n  padding: 6px 0px;\n}\n\n.animation_enter {\n  opacity: 0;\n  transform: translateY(-8px);\n}\n\n.animation_enterActive {\n  transition: all 160ms;\n  opacity: 1;\n  transform: translateY(0px);\n}\n\n.animation_exit {\n  opacity: 1;\n  transform: translateY(0px);\n}\n\n.animation_exitActive {\n  transition: all 160ms;\n  opacity: 0;\n  transform: translateY(-8px);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `menu-container-riBA0`,
	"animation_enter": `menu-animation_enter-Kcg_V`,
	"animation_enterActive": `menu-animation_enterActive-RYONc`,
	"animation_exit": `menu-animation_exit-E05_Y`,
	"animation_exitActive": `menu-animation_exitActive-Lo7bw`
};
export default ___CSS_LOADER_EXPORT___;
